import tw, { styled } from 'twin.macro';

import {
  StyledTitle,
  StyledDescription,
} from '@/components/StatBarBlock/components/StatBarBlockItem.styles';
import StatBarBlock from '@/components/StatBarBlock/StatBarBlock';
import {
  StyledTitle as StyledDescriptionTitle,
  StyledBodyText,
} from '@/components/StatBarBlock/StatBarBlock.styles';

export const StyledStatBarBlock = styled(StatBarBlock)<{ hasSideContent: boolean }>`
  ${({ hasSideContent }) => (hasSideContent ? tw`col-span-12` : tw`col-span-8 col-start-3`)}
  ${tw`w-full`}
  ${tw`bg-transparent`}
  ${tw`py-0!`}
  ${tw`my-[4px]`}

  ${StyledDescriptionTitle}, ${StyledBodyText} {
    ${({ hasSideContent }) => hasSideContent && tw`lg:col-span-12 lg:col-start-1 lg:text-left `}
  }

  ${StyledBodyText} {
    ${({ hasSideContent }) => hasSideContent && tw`lg:pb-0`}
  }

  ${StyledTitle} {
    ${tw`text-secondary-s1 text-heading-s`}
  }

  ${StyledDescription} {
    ${tw`text-body-s`}
  }
`;
